import { getRuntime } from './runtime';
export function registerApp(name, application) {
    const runtime = getRuntime();
    runtime.registerApp({ name, render: application(window.INITIAL_STATE[name]) });
}
